import { helper } from '@ember/component/helper';

export function extractDigits() {
  return function (value) {
    return typeof value === 'string' ? value.replace(/[\D]/gi, '') : value;
  };
}

export default helper(extractDigits);
